import React from "react";
import RiskFactorGraph from "../../components/risk-factor-graph";
import RiskGraph from "../../components/risk-line-graph";
import { getPercentileText2, findBucket } from "../../utils/results";

const ChartConfig = require("../../../json/ostp-config.json");

export const Mars_arthResults = (props) => {
  const { result, userName, nameEndsWithS } = props;

  console.log("Mars_arth result =", result);

  // No result to display
  if (!result || result.value === null || result.value === undefined) {
    return null;
  }

  const setupData = ChartConfig.setupData;

  const {
    Mars_arth_Risk,
    adjusted_Mars_arth_Risk,
    avg_Mars_arth_Result,
    avg_Adjusted_Mars_arth_Result,
    percentile_to_SD,
  } = setupData;

  const hasAdjustedResult =
    Object.prototype.hasOwnProperty.call(result, "adjusted_result") &&
    result.adjusted_result !== null &&
    result.adjusted_result !== undefined;

  const hasPercentile =
    Object.prototype.hasOwnProperty.call(result, "percentile") &&
    result.percentile !== null &&
    result.percentile !== undefined &&
    Number.isFinite(Number(result.percentile));

  const percentile = hasPercentile ? Number(result.percentile) : null;

  let ArthIndex;
  let ArthRiskPercent;
  let ArthRiskPercent2;

  if (hasAdjustedResult) {
    ArthIndex = findBucket(
      result.adjusted_result,
      avg_Adjusted_Mars_arth_Result,
    );

    ArthRiskPercent2 = adjusted_Mars_arth_Risk[ArthIndex];
  } else {
    ArthIndex = findBucket(result.value, avg_Mars_arth_Result);

    ArthRiskPercent = Mars_arth_Risk[ArthIndex];
  }

  let SD = null;
  let disease_risk = null;

  if (
    hasPercentile &&
    percentile >= 1 &&
    percentile <= percentile_to_SD.length
  ) {
    SD = percentile_to_SD[percentile - 1];

    if (SD !== undefined && SD !== null) {
      const OR = 1.72;
      disease_risk = Math.pow(OR, SD);
    }
  }

  return (
    <div>
      <div className="title-margins">
        <h2>
          {userName ? `${userName}'${nameEndsWithS ? "" : "s"}` : ""} Results
          for Rheumatoid Arthritis
        </h2>

        <h5>
          <a
            href="https://pubmed.ncbi.nlm.nih.gov/36347255/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mars et al. (2022)
          </a>
        </h5>
      </div>

      <div>
        <div className="title-break">
          <span>Your Results</span>
        </div>

        <div className="card">
          {hasAdjustedResult ? (
            <p>
              To use the graph, find the dot on the line that shows your genetic
              score. The grey histogram shows the number of people and their
              genetic scores. The bin containing your score tells how many other
              people have a score like yours. If your score is on the{" "}
              <strong>right side of the histogram</strong>, you will tend to
              have a higher risk for rheumatoid arthritis. Your score is
              comprised of both the genetic and clinical risk factor results.
            </p>
          ) : (
            <p>
              To use the graph, find the dot on the line that shows your genetic
              score. The grey histogram shows the number of people and their
              genetic scores. The bin containing your score tells how many other
              people have a score like yours. If your score is on the{" "}
              <strong>right side of the histogram</strong>, you will tend to
              have a higher risk for rheumatoid arthritis.
            </p>
          )}

          {hasPercentile && (
            <RiskGraph
              graphType="risk"
              percentile={percentile}
              crmKey={
                hasAdjustedResult
                  ? "results-adjusted-Mars_arth-histogram"
                  : "results-Mars_arth-histogram"
              }
            />
          )}

          <br />

          {hasPercentile && disease_risk !== null && (
            <p>
              You are in the <b>{getPercentileText2(percentile)} </b>
              and your risk for rheumatoid arthritis is{" "}
              <b>{disease_risk.toPrecision(2)}</b> fold compared to the average.
              {hasAdjustedResult && (
                <>
                  {" "}
                  Your height, sex, age and weight have been factored into your
                  score to better predict your risk for rheumatoid arthritis.
                </>
              )}
            </p>
          )}
        </div>

        <div className="title-break">
          <span>Comments</span>
        </div>

        <div className="card">
          <p>
            This study developed a polygenic risk score for rheumatoid arthritis
            that includes 1,083,565 variants based on 306,418 individuals
            (14,361 cases).
          </p>

          {hasAdjustedResult ? (
            <p>
              The polygenic risk score explains 0.87% of the variance in
              arthritis risk.
            </p>
          ) : (
            <p>
              The polygenic risk score explains 0.3% of the variance in
              arthritis risk.
            </p>
          )}

          <p>
            The study was performed on individuals of White British descent. It
            is unclear how these results generalize to other ancestry groups.
          </p>
        </div>

        {hasAdjustedResult && (
          <div>
            <div className="title-break">
              <span>
                Impact of Genetics and Age on Risk for Rheumatoid Arthritis
              </span>
            </div>

            <div className="card">
              <RiskFactorGraph
                graphMax={0.009}
                data={[0.002982, 0.005801, 0.008748]}
              />

              <p>
                The graph shows how risk for rheumatoid arthritis is affected by
                genetics, sex or both combined. The amount of risk is measured
                by "variance explained", where 1.00 means that the test predicts
                rheumatoid arthritis exactly and 0.00 means that there is no
                information. For rheumatoid arthritis, genetics has a smaller
                effect than sex, but combining them together has the most
                effect; overall, the combined score explains 0.87% of the
                variance in risk for rheumatoid arthritis.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Mars_arthResults;
